module.exports = __webpack_public_path__ + "img/51.4692895d.jpg";